import { useRef } from 'react'

const useScrollToElement = () => {
  const targetRefs = useRef([])

  const scrollToTarget = (index) => {
    targetRefs.current[index]?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
  }

  return { targetRefs, scrollToTarget }
}

export default useScrollToElement
